
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import CeoImage from 'styles/images/aboutus/ceo.jpg';

const NamingReason = () => {

    const Heart = ({ fill, size = 20 }) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={fill}
            stroke={fill === 'white' ? '#e5e7eb' : 'none'}
            strokeWidth="1.5"
            xmlns="http://www.w3.org/2000/svg"
            className="inline-block align-middle" // مهم: هم‌ترازی کامل
        >
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
    );

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                


                <p className={[ruleStyles['text-justify'], formStyles['!text-primary'], ruleStyles['font-weight-800']].join(' ')}>
                    وجه تسمیه (علت نامگذاری Dr20)
                </p>
                <p className={ruleStyles['text-justify']}>
                    بنده (مسعود صفار) در سال ۱۴۰۳، پزشک خانواده ی درمانگاهی در بلوار رحمت شیراز  بودم 
                </p>
                <p className={ruleStyles['text-justify']}>
                    یک روز صبح، شخص شیک و جنتلمنی با یک جواب آزمایش ،به من مراجعه کرد و درخواست کرد که آزمایش اش را براش،بخونم و تفسیر کنم.
                </p>
                <p className={ruleStyles['text-justify']}>
                    (توضیح اینکه، من همیشه ، اینگونه مواقع می پرسم که آیا بعلت چکاپ  آزمایش داده اید یا مشکل خاصی دارید؟)
                </p>
                <p className={ruleStyles['text-justify']}>
                    من همین سئوال را از اون شخص پرسیدم. ایشان در جواب گفتند که من چندین و چند ماه هست که صبح ها، مفاصل انگشتان دستم، مفاصل گردن و کمرم و …
                </p>
                <p className={ruleStyles['text-justify']}>
                    و خلاصه تمامی مفاصلم ، درد میکنه و با گذشت زمان و درطی روز، درد مفاصل ام کمتر میشه ولی کاملا برطرف نمیشه… این complaint (مشکل و شکایت بیمار) را در پزشکی ، میگن خشکی صبحگاهی مفاصل (Morning Stiffness )که یکی از علائم روماتیسم مفصلی ست.
                </p>
                <p className={ruleStyles['text-justify']}>
                    من، آزمایش بیمار را که چک کردم، متوجه شدم که تستهای غربالگری روماتیسم (ESR,CRP,RF) در جواب آزمایشها، موجود نیست … قسمت بالای ریپورت آزمایش را که نگاه کردم، نام یکی از اساتید و پزشکان خوب شیراز را دیدم ( احتمالا ، آزمایش مذکور، درخواست شده بوده ولی توسط پذیرش آزمایشگاه، در کامپیوتر ثبت نشده بوده و گزارش نشده بود) ضمنا بیمار شکایت داشت از پرنوشی (Polydipsia) و پلی یوریا(Polyuria)  که بیماری دیابت در تاپ لیست تشخیص افتراقی (Differential Diagnosis)  قرار می‌گیرد. در آزمایش‌های ایشون، قند خون ناشتا (FBS) بود ولی قندخون سه ماهه (HBA1C)  نبود. خلاصه بدلیل ناقص بودن آزمایش‌های ایشون، براشون آزمایش کامل درخواست کردم و دوهفته ی بعد، ایشون با جواب آزمایش کامل مراجعه کرد.
                </p>
                <p className={ruleStyles['text-justify']}>
                    یادم هست روز دوشنبه ای بود و ساعت تقریبا ۹ صبح..  
                </p>
                <p className={ruleStyles['text-justify']}>
                    جواب آزمایش را که دیدم ، آزمایشهای روماتیسم ایشون بالا و مثبت بود و با توجه به خشکی صبحگاهی مفاصل ایشون، تشخیص روماتیسم ایشون قطعی شد
                </p>
                <p className={ruleStyles['text-justify']}>
                    و ایشون را به یکی از اساتید خوب فوق تخصص روماتولوژی ارجاع دادم..‌ از طرفی بدلیل بالابودن قند خون ناشتا و قندخون سه ماهه، تشخیص دیابت ایشون هم مسجل شد و براشون در مورد تغییر سبک زندگی :(Life Style Change)
                </p>
                <p className={ruleStyles['text-justify']}>
                    ۱-ورزش و پیاده روی منظم روزانه به مدت حداقل ۴۵ دقیقه در هرروز، به نحوی که ضربان قلب و تنفس، ۱۰ درصد اضافه شود و شخص تعریق کند.
                </p>
                <p className={ruleStyles['text-justify']}>
                    ۲-منع مطلق استفاده از نوشابه و محدودیت در استفاده از قند،شکر،شیرینی و شربت و …
                </p>
                <p className={ruleStyles['text-justify']}>
                    مفصلا توضیح دادم و حتی برای درمان دیابت شون ، دارو هم تجویز کردم (چون FBS ایشون، 168 بود و HBA1C ایشون 8.8 )
                </p>
                <p className={ruleStyles['text-justify']}>
                    ویزیت این بیمار، حدود نیم ساعت طول کشید و موقع رفتن به من گفت: من تاجر شیرازی (بنام فلانی) هستم که سی سال هست تاجرم و ساکن لندن هستم. من وقتی میخوام برم پیش پزشک، وقتی که به پذیرش پزشک خانواده‌ام زنگ میزنم و نوبت پزشک میخوام، معمولا دوماهه بهم نوبت میده و ویزیتش هم، بالای چند میلیون تومان هست (مبلغ ویزیت آزاد ما در سال ۱۴۰۳، ۱۲۶ هزار تومان بود) و چندین و چند ماهه که این مشکلات را دارم و هربار که به پزشک خانواده‌ام در لندن مراجعه می‌کنم، با آنکه کاملا به زبان انگلیسی مسلط هستم و مشکل ارتباط برقرارکردن با پزشکم را ندارم، برام وقت کافی نمیذاره و در عرض دو سه دقیقه، فقط برام داروهای مسکن، تجویز میکنه و ...
                </p>
                <p className={ruleStyles['text-justify']}>
                    دستش را به این صورت 👌 به سمتم گرفت و گفت :
                </p>
                <p className={ruleStyles['text-justify']}>
                    شما واقعا دکتر بیستی هستی، بیست بیست
                </p>
                <p className={ruleStyles['text-justify']}>
                    وشب همون روز (شب دوشنبه) که این تاجر به بنده مراجعه کرد، خواب بسیار خوبی دیدم که سراسر نور و رحمت و برکت بود. (و برای بستگان و دوستان صمیمی‌ام، جزئیات این خواب را تعریف کرده‌ام) موقعی که خوابم تموم شد، با صدای اذان صبح که از گوشی موبایلم، طنین انداز شد، بیدار شدم. همزمانی این خواب و صحبت و تمجید این بیمار، جرققققه ااای در ذهن من زد …..
                </p>
                <p className={ruleStyles['text-justify']}>
                    [اتفاقا اون روز، بیمار پزشک خانواده، در صف انتظار (پشت درب اتاق من) نبود]
                </p>
                <p className={ruleStyles['text-justify']}>
                    بعد از اینکه این بیمار، از اتاق من خارج شد، گوشی موبایلم را برداشتم و در گوگل، نام Dr20 را سرچ کردم … اومد:
                </p>
                <p className={ruleStyles['text-justify']}>
                    dr20medical.com و وقتی که کلیک کردم، متوجه شدم که این شرکت، تشک‌های طبی تولید میکنه و موضوع فعالیت این شرکت، ربطی به طرح و ایده ی من نداشت. و سریعا اولین کاری که کردم، دامنه‌ی Dr20 را بنام Dr20.org ثبت و رجیستر کردم….
                </p>
                <p className={ruleStyles['text-justify']}>
                    <div className={[sharedStyles.flex, sharedStyles.itemsCenter].join(' ')}>
                        <span style={{marginLeft: '5px'}}>و….. یا علی گفتیم و عشق آغاز شد  </span>
                        <Heart fill="#10b981" /> {/* سبز */}
                        <Heart fill="white" stroke="#e5e7eb" /> {/* سفید با حاشیه */}
                        <Heart fill="#ef4444" /> {/* قرمز */}
                    </div>
                </p>
                {/*<p className={ruleStyles['text-justify']}>
                    و الان که چند ماهه که از استارت پروژه Dr20 میگذره،
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles['!text-purple'], sharedStyles['font-weight-600']].join(' ')}>
                    این آیه شریفه (آیه 82 ) سوره مبارکه یس ، تو ذهنم میاد که
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles['!text-purple'], sharedStyles['font-weight-600']].join(' ')}>
                    خداوند سبحان میفرماید:
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles['!text-purple'], sharedStyles['font-weight-600']].join(' ')}>
                    انما امره اذا اراد شیئا 
                    <br />
                    ان یقول له کن فیکون
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles['!text-purple'], sharedStyles['font-weight-600']].join(' ')}>
                    (خداوند سبحان) هنگامی که
                    <br />
                    به چیزی اراده فرماید، به
                    <br />
                    محض اینکه میگوید: «باش»، 
                    <br />
                    پس (بی درنگ) موجود میشود
                </p>*/}

            </div>
                
        </div>

    );
}

export default NamingReason;